import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { Component, Input, TemplateRef } from '@angular/core';
import { faAngleDown, faAngleRight, faCircleInfo, faXmark } from '@fortawesome/free-solid-svg-icons';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Observable, Subject } from 'rxjs';
import { MachinePartInfoData } from 'src/app/shared/services/machine-part-info.service';

@Component({
  selector: 'app-machine-part-info',
  templateUrl: './machine-part-info.component.html',
  styleUrl: './machine-part-info.component.scss'
})
export class MachinePartInfoComponent {
  faAngleDown = faAngleDown;
  faAngleRight = faAngleRight;
  faXmark = faXmark;
  faCircleInfo = faCircleInfo;
  isSmallScreen: boolean = false;
  modalRef?: BsModalRef;
  isShowed: boolean[] = [];
  private _unsubscriber = new Subject();

  @Input()
  currentMachineId!: Observable<string | undefined>;

  constructor(
    private _mpSvc: MachinePartInfoData,
    private breakpointObserver: BreakpointObserver,
    private _modalService: BsModalService,
  ) { }

  ngOnInit(): void {
    this._mpSvc.IsActive = true;

    this.currentMachineId.subscribe(id => {
      if(id) {
        this._mpSvc.CurrentRowId = id;
      }
    });

    this.breakpointObserver
      .observe([Breakpoints.HandsetPortrait])
      .subscribe((state: BreakpointState) => {
        this.isSmallScreen = state.matches;
      });
  }

  ngOnDestroy(): void {
    this._unsubscriber.next(null);
    this._unsubscriber.complete();
    this._mpSvc.IsActive = false;
  }

  public get MpSvc(): MachinePartInfoData{
    return this._mpSvc;
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this._modalService.show(template);
  }

  decline(): void {
    this.modalRef?.hide();
  }

  show(rowIndex: number): void {
    this.isShowed[rowIndex] = !this.isShowed[rowIndex];
  }
}
